<template>
  <div class="BookView container-fluid">
    <BookMap
      :style="`height: calc(100% - ${propsNavBar.height})`"
      class="full-width Map-container"
    />

    <RouterView />
  </div>
</template>

<script>

import { mapMutations, mapGetters, mapState } from 'vuex';
import * as UserAccountModule from '@/store/modules/App/UserAccount/UserAccountModule';
import * as CitiesModule from '@/store/modules/App/Cities/CitiesModule';
import { Geolocation as GeolocationService } from '@/services';
import * as MapModule from './Map/MapModule';
import BookMap from './Map/MapComponent';

// TODO: It should be a Sass variable and we have to export to JS using a webpack plugin!
// https://itnext.io/sharing-variables-between-js-and-sass-using-webpack-sass-loader-713f51fa7fa0
const headerSize = 64;

export default {
  name: 'BookView',
  components: {
    BookMap,
  },
  data() {
    return {
      propsNavBar: {
        height: `${headerSize}px`,
      },
      geolocationService: {},
    };
  },
  computed: {
    ...mapState(CitiesModule.FULL_NAMESPACE, {
      cities: state => state.cities,
      STATUS: state => state.STATUS,
    }),
    ...mapState(UserAccountModule.FULL_NAMESPACE, {
      defaultCityUserAccount: state => state.data.defaultCityUuid,
    }),
    ...mapGetters(CitiesModule.FULL_NAMESPACE, {
      getCityByUuid: CitiesModule.GETTERS.GET_CITY_BY_UUID,
    }),
    ...mapState(MapModule.FULL_NAMESPACE, {
      isDefaultMapCenterNeeded: state => state.bookMap.viewNeedsDefaultMapCenter,
    }),
    isCitiesAndUserAccountFilled() {
      return !!this.STATUS.LOADED && !!this.defaultCityUserAccount;
    },
  },
  watch: {
    isCitiesAndUserAccountFilled(val) {
      if (val) {
        this.initMap();
      }
    },
  },
  mounted() {
    this.geolocationService = GeolocationService.getInstance();
    if (this.isCitiesAndUserAccountFilled) {
      this.initMap();
    }
  },
  methods: {
    ...mapMutations(MapModule.FULL_NAMESPACE, {
      smBookMapSetCenter: MapModule.MUTATIONS.SET_BOOK_MAP_CENTER,
    }),
    async initMap() {
      // const geolocationService = GeolocationService.getInstance();

      const city = await this.getCityByUuid(this.defaultCityUserAccount);

      this.geolocationService.setLatitudeAndLongitude(city.gps_lat, city.gps_lng);

      if (this.isDefaultMapCenterNeeded) {
        this.smBookMapSetCenter({
          lat: parseFloat(city.gps_lat),
          lng: parseFloat(city.gps_lng),
        });
      }

      this.geolocationService
        .getNavigatorGeolocation()
        .then((service) => {
          if (this.isDefaultMapCenterNeeded) {
            this.smBookMapSetCenter({
              lat: service.getLatitude(),
              lng: service.getLongitude(),
            });
          }
        })
        .catch({

        });
    },
  },
};
</script>
